"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ExtendedSearchBox = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set-timeout"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/find"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _pickers = require("@fluentui/react/lib/components/pickers");

var _SelectedItemDefault = require("@fluentui/react/lib/components/pickers/PeoplePicker/PeoplePickerItems/SelectedItemDefault");

var _ContextualMenu = require("@fluentui/react/lib/ContextualMenu");

var _Icon = require("@fluentui/react/lib/Icon");

var React = _interopRequireWildcard(require("react"));

var _ExtendedSearchBox = require("./ExtendedSearchBox.types");

var _SearchInput = require("./SearchInput");

var _SuggestionsContextMenu = require("./SuggestionsContextMenu");

/* Ported from https://outlookweb.visualstudio.com/Outlook%20Web */
var styles = require('./SearchBox.scoped.scss');

var getPersonaPillsChanges = function getPersonaPillsChanges(prevPersonaPills, nextPersonaPills) {
  if (prevPersonaPills !== undefined && nextPersonaPills !== undefined && prevPersonaPills !== nextPersonaPills) {
    var itemsRemoved = (0, _filter.default)(prevPersonaPills).call(prevPersonaPills, function (value) {
      return (0, _find.default)(nextPersonaPills).call(nextPersonaPills, function (searchElement) {
        return searchElement.objectId === value.objectId;
      }) === undefined;
    });
    var itemsAdded = (0, _filter.default)(nextPersonaPills).call(nextPersonaPills, function (value) {
      return (0, _find.default)(prevPersonaPills).call(prevPersonaPills, function (searchElement) {
        return searchElement.objectId === value.objectId;
      }) === undefined;
    });
    return {
      itemsAdded: itemsAdded,
      itemsRemoved: itemsRemoved
    };
  }

  return {
    itemsAdded: [],
    itemsRemoved: []
  };
};

var ExtendedSearchBox = /*#__PURE__*/function (_BaseComponent) {
  (0, _inherits2.default)(ExtendedSearchBox, _BaseComponent);

  var _super = (0, _createSuper2.default)(ExtendedSearchBox);

  function ExtendedSearchBox(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ExtendedSearchBox);
    _this = _super.call(this, props);
    _this.folderFilterButton = void 0;
    _this.searchBox = void 0;
    _this.searchBoxContainer = void 0;
    _this.searchInput = void 0;

    _this.isEmpty = function () {
      var _context;

      var personaPills = _this.props.personaPills;
      var searchTermEmpty = _this.props.searchText === undefined || (0, _trim.default)(_context = _this.props.searchText).call(_context).length === 0;
      var hasPills = personaPills !== undefined && personaPills.length > 0;
      return searchTermEmpty && !hasPills;
    };

    _this.hasFocus = function () {
      var _this$searchBoxContai;

      var showFiltersMenu = _this.props.showFiltersMenu;
      return !!((_this$searchBoxContai = _this.searchBoxContainer) === null || _this$searchBoxContai === void 0 ? void 0 : _this$searchBoxContai.contains(document.activeElement)) || !!showFiltersMenu;
    };

    _this._onPinSearchClick = function (evt) {
      var _this$searchInput, _this$props$toggleSav, _this$props, _this$props$searchTex;

      evt.stopPropagation();
      (_this$searchInput = _this.searchInput) === null || _this$searchInput === void 0 ? void 0 : _this$searchInput.setFocus();
      (_this$props$toggleSav = (_this$props = _this.props).toggleSaveSearch) === null || _this$props$toggleSav === void 0 ? void 0 : _this$props$toggleSav.call(_this$props, (_this$props$searchTex = _this.props.searchText) !== null && _this$props$searchTex !== void 0 ? _this$props$searchTex : '');
    };

    _this._onFilterItemClicked = function (_ev, item) {
      if (_this.props.selectFilterItem !== undefined && (item === null || item === void 0 ? void 0 : item.key) !== undefined && (item === null || item === void 0 ? void 0 : item.key) !== _this.props.selectedFilterKey) {
        _this.props.selectFilterItem(item.key);

        _this._onFilterScopeChanged();
      }
    };

    _this._filterDismissed = function () {
      if (_this.props.hideFilter !== undefined && _this.props.showFiltersMenu) {
        _this.props.hideFilter();
      }
    };

    _this._onFilterClick = function (evt) {
      var _this$props$onFilterC, _this$props2;

      evt.stopPropagation();
      (_this$props$onFilterC = (_this$props2 = _this.props).onFilterClick) === null || _this$props$onFilterC === void 0 ? void 0 : _this$props$onFilterC.call(_this$props2);
    };

    _this._onFilterScopeChanged = function () {
      // Start search only when search box is not empty
      if (!_this.isEmpty()) {
        _this._onSearch('SearchScopeRefiner');
      } else {
        // Else put focus back in search input
        _this.setFocus();
      }
    };

    _this._onKeyDownOnFilter = function (ev) {
      _this._onExecuteByKeyboard(ev, _this.props.onFilterClick);
    };

    _this._onKeyDownOnExecuteSearch = function (ev) {
      _this._onExecuteByKeyboard(ev, _this._onExecuteSearch, 'Keyboard');
    };

    _this._onBackKeyDown = function (ev) {
      _this._onExecuteByKeyboard(ev, _this.props.onBackClick);
    };

    _this._onExecuteByKeyboard = function (ev, onClick, actionSource) {
      switch (ev.keyCode) {
        case _react.KeyCodes.enter:
        case _react.KeyCodes.space:
          ev.stopPropagation();
          ev.preventDefault();
          onClick === null || onClick === void 0 ? void 0 : onClick(actionSource);
          break;
      }
    };

    _this._onKeyDownOnInputBox = function (evt) {
      evt.stopPropagation();
      var selectedSuggestionIndex = _this.props.selectedSuggestionIndex;
      var suggestionsCount = _this.props.suggestionsSet && _this.props.suggestionsSet.suggestions.length || 0;

      switch (evt.keyCode) {
        case _react.KeyCodes.enter:
          {
            var _this$searchInput2;

            // Send out a search only if the search box is not empty
            // If it is, then it is a no op
            _this._onSearch('Keyboard'); // Update suggestion text so that suggestion shows up correctly next time
            // This is necessary since onSearchTextChange is called only when user types in


            if (_this.props.setSearchTextForSuggestion !== undefined && _this.props.setSelectedSuggestionIndex !== undefined) {
              var _this$props$searchTex2;

              _this.props.setSearchTextForSuggestion((_this$props$searchTex2 = _this.props.searchText) !== null && _this$props$searchTex2 !== void 0 ? _this$props$searchTex2 : '');

              if (_this.props.selectedSuggestionIndex !== undefined) {
                _this.props.setSelectedSuggestionIndex(undefined);
              }
            }

            (_this$searchInput2 = _this.searchInput) === null || _this$searchInput2 === void 0 ? void 0 : _this$searchInput2.blur();
            break;
          }

        case _react.KeyCodes.backspace:
          {
            // If we do not have any searchText we will try to remove a persona pill if there is any
            if (_this.props.searchText === undefined || _this.props.searchText.length === 0) {
              var personaPills = _this.props.personaPills;

              if (personaPills === undefined) {
                personaPills = [];
              }

              var length = personaPills.length;

              if (length > 0) {
                _this._removePersona(personaPills[length - 1]);
              }
            }

            if (_this.props.setSelectedSuggestionIndex !== undefined && _this.props.selectedSuggestionIndex !== undefined) {
              _this.props.setSelectedSuggestionIndex(undefined);
            }

            break;
          }

        /**
         * For navigation key, we would like to have suggestion shown
         * with the current index and default behavior of input field for the key
         */

        case _react.KeyCodes.pageUp:
        case _react.KeyCodes.pageDown:
        case _react.KeyCodes.end:
        case _react.KeyCodes.home:
        case _react.KeyCodes.left:
        case _react.KeyCodes.right:
          {
            break;
          }

        /**
         * Update suggestion index and text for up/down key
         */

        case _react.KeyCodes.up:
          {
            // Prevent default behavior where cursor moves to the beginning of input field
            // This is used for UP only and we don't need for DOWN since default behavior
            // for DOWN is to move cursor to the end of input filed
            evt.preventDefault();

            if (_this.props.selectSuggestionByIndex !== undefined && selectedSuggestionIndex != null && selectedSuggestionIndex > 0 && selectedSuggestionIndex < suggestionsCount) {
              _this.props.selectSuggestionByIndex(selectedSuggestionIndex - 1);
            }

            break;
          }

        case _react.KeyCodes.down:
          {
            if (_this.props.selectSuggestionByIndex !== undefined && (selectedSuggestionIndex === undefined || selectedSuggestionIndex < suggestionsCount - 1)) {
              _this.props.selectSuggestionByIndex(selectedSuggestionIndex !== undefined ? selectedSuggestionIndex + 1 : 0);
            }

            break;
          }

        default:
          {
            // Clear suggestion index and text if none of navigation key is pressed
            if (_this.props.setSelectedSuggestionIndex !== undefined && _this.props.selectedSuggestionIndex !== undefined) {
              _this.props.setSelectedSuggestionIndex(undefined);
            }
          }
      }
    };

    _this._removePersona = function (persona) {
      if (_this.props.removePersona !== undefined) {
        _this.props.removePersona(persona);
      }
    };

    _this._addPersona = function (suggestion) {
      if (_this.props !== undefined) {
        var _this$props$addPerson, _this$props3;

        (_this$props$addPerson = (_this$props3 = _this.props).addPerson) === null || _this$props$addPerson === void 0 ? void 0 : _this$props$addPerson.call(_this$props3, suggestion);
      }
    };

    _this._onStartSearchFromSuggestion = function (searchText) {
      // Set index to default after search executed
      if (_this.props.setSelectedSuggestionIndex !== undefined && _this.props.selectedSuggestionIndex !== undefined) {
        _this.props.setSelectedSuggestionIndex(undefined);
      } // When user clicks on a suggestion dropdown and selects a suggestion
      // we have to explicity set the search text in the store.


      if (_this.props.addKeywordSuggestion !== undefined) {
        _this.props.addKeywordSuggestion(searchText);
      } // Also update suggestion text so that suggestion shows up correctly next time.


      if (_this.props.setSearchTextForSuggestion !== undefined) {
        _this.props.setSearchTextForSuggestion(searchText);
      }

      _this._onSearch('SearchBoxSuggestionDropDown');
    };

    _this._onUnpinSearchClick = function (query) {
      var _this$props$toggleSav2, _this$props4;

      _this.setFocus();

      (_this$props$toggleSav2 = (_this$props4 = _this.props).toggleSaveSearch) === null || _this$props$toggleSav2 === void 0 ? void 0 : _this$props$toggleSav2.call(_this$props4, query);
    };

    _this._onSearchBoxClick = function (evt) {
      evt.stopPropagation();

      _this.setFocus();
    };

    _this._onSearchInputFocus = function () {
      if (_this.props.onFocused) {
        _this.props.onFocused();
      }
    };

    _this._onSearchBoxBlur = function (evt) {
      var relatedTargetElement = evt.relatedTarget;
      var clickSourceProperty = 'clickSource';
      var isBlurSourceFromSearchBoxContainer = relatedTargetElement ? relatedTargetElement.dataset[clickSourceProperty] === _ExtendedSearchBox.SEARCH_BOX_SOURCE : false;

      if (!isBlurSourceFromSearchBoxContainer && _this.props.onBlurred) {
        _this.props.onBlurred();
      }
    };

    _this._onExecuteSearchClick = function (evt) {
      evt.stopPropagation();

      _this._onExecuteSearch('SearchButton');

      if (!_this.isEmpty()) {
        var _this$searchInput3;

        (_this$searchInput3 = _this.searchInput) === null || _this$searchInput3 === void 0 ? void 0 : _this$searchInput3.blur();

        if (_this.props.onBlurred !== undefined) {
          _this.props.onBlurred();
        }
      }
    };

    _this._onExecuteSearch = function (actionSource) {
      var isSearchBoxEmpty = _this.isEmpty();

      if (!isSearchBoxEmpty) {
        // If we have something in the search box then start search
        _this._onSearch(actionSource !== null && actionSource !== void 0 ? actionSource : '');
      } else {
        // Else put focus back in search input
        _this.setFocus();
      }
    };

    _this._onSearch = function (actionSource) {
      if (_this.props.onSearch !== undefined) {
        _this.props.onSearch(actionSource);
      }
    };

    _this._onBackClick = function (evt) {
      evt.stopPropagation();

      if (_this.props.onBackClick !== undefined) {
        _this.props.onBackClick();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ExtendedSearchBox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$personaPil,
          _this$props$personaPi,
          _this2 = this;

      var _getPersonaPillsChang = getPersonaPillsChanges((_prevProps$personaPil = prevProps.personaPills) !== null && _prevProps$personaPil !== void 0 ? _prevProps$personaPil : [], (_this$props$personaPi = this.props.personaPills) !== null && _this$props$personaPi !== void 0 ? _this$props$personaPi : []),
          itemsRemoved = _getPersonaPillsChang.itemsRemoved,
          itemsAdded = _getPersonaPillsChang.itemsAdded;

      if (itemsRemoved.length === 1 && itemsAdded.length === 0) {
        // Rasing an event from property changes should be async
        (0, _setTimeout2.default)(function () {
          return _this2._onPersonaRemoved();
        });
      }
    }
    /**
     * Returns a flag indicating whether the search box control is empty
     */

    /**
     * Returns flag indicating whether the document active element is contained within search box container OR
     * Filter dropdown is being shown, in which case the focus could be inside the filter drop down
     */

  }, {
    key: "setFocus",

    /**
     * Sets/puts focus on the search input
     */
    value: function setFocus() {
      var _this$searchInput4;

      (_this$searchInput4 = this.searchInput) === null || _this$searchInput4 === void 0 ? void 0 : _this$searchInput4.setFocus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var personaPills = this.props.personaPills;

      if (personaPills === undefined) {
        personaPills = [];
      } // We expand the search box when in search session


      var isSearchBoxExpanded = this.props.isSearchBoxExpanded;
      var shouldRenderPinIcon = this.props.shouldRenderPinIcon;
      var suggestionsSet = this.props.suggestionsSet;
      var shouldShowSuggestions = this.props.isFocusInSearch && !this.props.showFiltersMenu && suggestionsSet !== undefined && suggestionsSet.suggestions.length > 0;
      var showPinIcon = shouldRenderPinIcon && this.props.shouldShowPinSearchIcon;
      var maxWidthValue;

      if (!isSearchBoxExpanded) {
        maxWidthValue = this.props.customCollapsedMaxWidth ? this.props.customCollapsedMaxWidth : _ExtendedSearchBox.DEFAULT_COLLAPSED_WIDTH;
      } else {
        maxWidthValue = _ExtendedSearchBox.DEFAULT_EXPANDED_WIDTH;
      }

      var searchBoxContainerClassNames = (0, _react.css)(styles.searchBoxContainer, isSearchBoxExpanded && styles.inSearch);
      var searchBoxContainerStyle = {
        maxWidth: maxWidthValue + 'px'
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        role: "search",
        className: (0, _react.css)('ms-SearchBox', searchBoxContainerClassNames),
        style: searchBoxContainerStyle,
        ref: this._resolveRef('searchBoxContainer'),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles.searchBox,
          ref: this._resolveRef('searchBox'),
          children: [shouldShowSuggestions && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SuggestionsContextMenu.SuggestionsContextMenu, {
            onPeopleSuggestionClick: this._addPersona,
            onTextSuggestionClick: this._onStartSearchFromSuggestion,
            targetElement: this.searchBox,
            onUnpinSearchClicked: this._onUnpinSearchClick,
            shouldShowPinSearchIcon: this.props.shouldShowPinSearchIcon,
            suggestionsSet: this.props.suggestionsSet,
            selectedSuggestionIndex: this.props.selectedSuggestionIndex,
            personaPills: this.props.personaPills
          }), ' ',
          /* Left side - Back Icon or Search Icon Button */
          isSearchBoxExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles.backIcon // This custom property is required to not call props.blur inside onSearchBoxBlur
            ,
            "data-click-source": _ExtendedSearchBox.SEARCH_BOX_SOURCE,
            onBlur: this._onSearchBoxBlur,
            onClick: this._onBackClick,
            onKeyDown: this._onBackKeyDown,
            tabIndex: 0,
            title: this.props.backButtonTitle,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: 'Back'
            })
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            onBlur: this._onSearchBoxBlur,
            className: styles.searchIcon,
            "aria-hidden": true,
            onClick: this._onSearchBoxClick,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: 'Search'
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            onClick: this._onSearchBoxClick,
            className: styles.searchQueryContainer,
            children: [personaPills && personaPills.length > 0 && (0, _map.default)(personaPills).call(personaPills, function (personaPill, index) {
              var removePersona = function removePersona() {
                return _this3._removePersona(personaPill);
              };

              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectedItemDefault.SelectedItemDefault, {
                item: {
                  primaryText: personaPill.primaryText,
                  ValidationState: _pickers.ValidationState.valid
                },
                index: index,
                onRemoveItem: removePersona,
                removeButtonAriaLabel: _this3.props.removePersonaButtonAriaLabel
              }, index);
            }),
            /*#__PURE__*/

            /* Search Input control */
            (0, _jsxRuntime.jsx)(_SearchInput.SearchInput, {
              ref: this._resolveRef('searchInput'),
              searchText: this.props.searchText,
              disabled: this.props.disabled,
              onSearchChange: this.props.onChange,
              onBlur: this._onSearchBoxBlur,
              onFocus: this._onSearchInputFocus,
              onKeyDown: this._onKeyDownOnInputBox,
              searchPlaceholderText: this.isEmpty() && this.props.searchPlaceholderText || ''
            })]
          }),
          /* Save search Pin icon */
          isSearchBoxExpanded && showPinIcon && this._renderPinIcon(),
          /* Search scope filter Button */
          // If no callback for the search click is passed, dont need to render the search filter
          this.props.showFiltersIcon && isSearchBoxExpanded && this.props.onFilterClick && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            tabIndex: 0,
            className: (0, _react.css)(styles.filterContainer, showPinIcon && styles.filterWithPin),
            ref: this._resolveRef('folderFilterButton'),
            "data-click-source": _ExtendedSearchBox.SEARCH_BOX_SOURCE,
            onBlur: this._onSearchBoxBlur,
            onClick: this._onFilterClick,
            onKeyDown: this._onKeyDownOnFilter,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: styles.filterText,
              children: getSearchFilterDisplay(this.props)
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              iconName: this._getFilterIcon(),
              className: styles.filterDropDownIcon
            }), this.props.showFiltersMenu && this._renderRefiners()]
          })]
        }),
        /* Execute search Icon Button */
        isSearchBoxExpanded && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
          tabIndex: 0,
          "data-click-source": _ExtendedSearchBox.SEARCH_BOX_SOURCE,
          onBlur: this._onSearchBoxBlur,
          onClick: this._onExecuteSearchClick,
          onKeyDown: this._onKeyDownOnExecuteSearch,
          className: styles.executeSearchIcon,
          title: this.props.executeSearchLabel,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            iconName: 'Search'
          })
        })]
      });
    }
  }, {
    key: "_renderRefiners",
    value: function _renderRefiners() {
      var _this$props$filterIte, _this$props$filterIte2;

      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContextualMenu.ContextualMenu, {
        target: this.folderFilterButton,
        items: (_this$props$filterIte = (_this$props$filterIte2 = this.props.filterItems) === null || _this$props$filterIte2 === void 0 ? void 0 : (0, _map.default)(_this$props$filterIte2).call(_this$props$filterIte2, function (item, index) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
            onClick: undefined
          });
        })) !== null && _this$props$filterIte !== void 0 ? _this$props$filterIte : [],
        onItemClick: this._onFilterItemClicked,
        onDismiss: this._filterDismissed,
        shouldFocusOnMount: true,
        directionalHintFixed: true // ensure the position will not change sides in an attempt to fit the callout within bounds.
        ,
        gapSpace: 2 // we need a 2 px gap between the suggestions menu and the box when search is in header
        ,
        directionalHint: _ContextualMenu.DirectionalHint.bottomRightEdge
      });
    }
  }, {
    key: "_renderPinIcon",
    value: function _renderPinIcon() {
      var icon;
      var tooltip;

      if (this.props.isTextAlreadyPinned) {
        icon = 'Pinned';
        tooltip = this.props.unpinSearchLabel;
      } else {
        icon = 'Pin';
        tooltip = this.props.pinSearchLabel;
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles.pinIconContainer,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          className: styles.pinIcon,
          iconName: icon,
          tabIndex: 0,
          title: tooltip,
          onClick: this._onPinSearchClick
        })
      });
    }
    /**
     * Called when user clicks on the folder filter dropdown title in search box
     */

    /**
     * Called when user changes the folder scope from folder filter drop down
     */

    /**
     * Called when user presses keyboard on the filter dropdown title in search box
     */

    /**
     * Called when user presses keyboard on the execute search button in search box
     */

    /**
     * Called when user presses keyboard on back button on the search box.
     */

    /**
     * Called when user presses keyboard on a button control
     */

    /**
     * Keyboard event handler for the input box
     */

    /**
     * Remove persona
     */

  }, {
    key: "_onPersonaRemoved",
    value: function _onPersonaRemoved() {
      if (this.isEmpty()) {
        // focus search input if the box is empty
        this.setFocus();
      } else {
        // start search if box is not empty
        this._onSearch('NonUserAction');
      }
    }
    /**
     * Add persona and start search
     */

    /**
     * Start search and set focus on the input box as the search is performed by selecting something from suggestions menu
     */

    /**
     * Event handler called when user clicks on the search icon on the search box control or
     * when they click on the editable part of the search box
     */

    /**
     * Called when search input gains focus.
     * Call wrapper components onFocused function
     */

    /**
     * Search box can lose focus in multiple cases such as below:
     * a) user clicks out side of the search box,
     * b) tabs outside of the search box.
     *
     * We check if related target that will get the next focus is inside the search box container
     * If it is not then the search box control has no element that has a focus
     * so call wrapper components onBlurred function.
     */

    /**
     * Called when a search icon that appears on the right side of the search box is clicked
     */

    /**
     * Called when a search icon is pressed or clicked
     */

    /**
     * Called whenever user interaction happened and we want to start search
     */

    /**
     * Called when back button on the search box is clicked.
     */

  }, {
    key: "_getFilterIcon",
    value: function _getFilterIcon() {
      return 'Filter';
    }
  }]);
  return ExtendedSearchBox;
}(_react.BaseComponent);

exports.ExtendedSearchBox = ExtendedSearchBox;

var getSearchFilterDisplay = function getSearchFilterDisplay(props) {
  var _context2;

  if (props.filterItems === undefined) {
    return '';
  }

  var selectedItem = (0, _find.default)(_context2 = props.filterItems).call(_context2, function (item) {
    return item.key === props.selectedFilterKey;
  });
  return selectedItem !== undefined ? selectedItem.name : props.filterItems[0].name;
};